/**
 * Учебные вилки для макета карточки. Цифры с живого скрина и рядом с ним.
 * В кассу по ним ходить нельзя.
 */

export interface LabLeg {
  source: string;
  name: string;
  pick: string;
  odds: string;
  enter: string;
  enterUnit: string;
  age: string;
  color: string;
  mark: string;
  cents?: string;
  cost?: string;
  entry: 'form' | 'event' | 'section';
}

export interface LabFork {
  id: string;
  /** Коротко: победа, тотал, фора — заголовок над карточкой. */
  kind: string;
  match: string;
  sport: string;
  market: string;
  profit: number;
  roiPct: number;
  staked: number;
  payout: number;
  legs: [LabLeg, LabLeg];
}

export const LAB_FORKS: LabFork[] = [
  {
    id: 'win',
    kind: 'победа',
    match: 'Leo Borg — Stefan Seifert',
    sport: 'теннис',
    market: 'матч · победа',
    profit: 1183,
    roiPct: 11.83,
    staked: 10000,
    payout: 11183,
    legs: [
      {
        source: 'kalshi',
        name: 'Kalshi',
        pick: 'победа Stefan Seifert',
        odds: '2.439',
        enter: '144.8',
        enterUnit: 'шер',
        age: '3 с',
        color: '#1f8a4c',
        mark: 'K',
        cents: '41',
        cost: 'спишут 59.37 $ ≈ 4 817 ₽',
        entry: 'section',
      },
      {
        source: 'bovada',
        name: 'Bovada',
        pick: 'победа Leo Borg',
        odds: '2.200',
        enter: '5183',
        enterUnit: '₽',
        age: '10 с',
        color: '#b33a3a',
        mark: 'B',
        entry: 'event',
      },
    ],
  },
  {
    id: 'total',
    kind: 'тотал',
    match: 'Leo Borg — Stefan Seifert',
    sport: 'теннис',
    market: 'матч · тотал геймов',
    profit: 640,
    roiPct: 6.4,
    staked: 10000,
    payout: 10640,
    legs: [
      {
        source: 'pinnacle',
        name: 'Pinnacle',
        pick: 'тотал геймов больше 21.5',
        odds: '1.920',
        enter: '5208',
        enterUnit: '₽',
        age: '4 с',
        color: '#e0555f',
        mark: 'P',
        entry: 'event',
      },
      {
        source: 'bovada',
        name: 'Bovada',
        pick: 'тотал геймов меньше 21.5',
        odds: '2.080',
        enter: '4792',
        enterUnit: '₽',
        age: '7 с',
        color: '#b33a3a',
        mark: 'B',
        entry: 'event',
      },
    ],
  },
  {
    id: 'hcp',
    kind: 'фора',
    match: 'Leo Borg — Stefan Seifert',
    sport: 'теннис',
    market: 'матч · фора по сетам',
    profit: 510,
    roiPct: 5.1,
    staked: 10000,
    payout: 10510,
    legs: [
      {
        source: 'kalshi',
        name: 'Kalshi',
        pick: 'фору Seifert +1.5',
        odds: '1.850',
        enter: '162.2',
        enterUnit: 'шер',
        age: '5 с',
        color: '#1f8a4c',
        mark: 'K',
        cents: '54',
        cost: 'спишут 87.59 $ ≈ 7 104 ₽',
        entry: 'section',
      },
      {
        source: 'pinnacle',
        name: 'Pinnacle',
        pick: 'фору Borg −1.5',
        odds: '2.150',
        enter: '2896',
        enterUnit: '₽',
        age: '6 с',
        color: '#e0555f',
        mark: 'P',
        entry: 'event',
      },
    ],
  },
  {
    id: 'set',
    kind: 'сет',
    match: 'Leo Borg — Stefan Seifert',
    sport: 'теннис',
    market: '1-й сет · победа',
    profit: 390,
    roiPct: 3.9,
    staked: 10000,
    payout: 10390,
    legs: [
      {
        source: 'polymarket',
        name: 'Polymarket',
        pick: '1-й сет — Stefan Seifert',
        odds: '2.170',
        enter: '88.5',
        enterUnit: 'шер',
        age: '2 с',
        color: '#5b82f0',
        mark: 'P',
        cents: '46',
        cost: 'спишут 40.71 $ ≈ 3 302 ₽',
        entry: 'form',
      },
      {
        source: 'bovada',
        name: 'Bovada',
        pick: '1-й сет — Leo Borg',
        odds: '1.870',
        enter: '6698',
        enterUnit: '₽',
        age: '9 с',
        color: '#b33a3a',
        mark: 'B',
        entry: 'event',
      },
    ],
  },
  {
    id: 'btts',
    kind: 'обе забьют',
    match: 'Спартак — Зенит',
    sport: 'футбол',
    market: 'матч · обе забьют',
    profit: 280,
    roiPct: 2.8,
    staked: 10000,
    payout: 10280,
    legs: [
      {
        source: 'fonbet',
        name: 'Фонбет',
        pick: 'обе забьют — да',
        odds: '1.780',
        enter: '5618',
        enterUnit: '₽',
        age: '11 с',
        color: '#2bb573',
        mark: 'Ф',
        entry: 'event',
      },
      {
        source: 'pinnacle',
        name: 'Pinnacle',
        pick: 'обе забьют — нет',
        odds: '2.200',
        enter: '4382',
        enterUnit: '₽',
        age: '8 с',
        color: '#e0555f',
        mark: 'P',
        entry: 'event',
      },
    ],
  },
];

export const LAB_FORK = LAB_FORKS[0];

export const rub = (n: number): string =>
  new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n);

export const copy = async (text: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // Макет: буфер может быть закрыт.
  }
};
